export default __webpack_public_path__ + "static/media/thumb.31ed5b34.svg";